import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';
import { OfferTicketList } from './OfferTicket';
import { useOfferNow } from './offerMotion';
import type { CampaignOffer } from './campaignOfferCopy';

/** The header chip's panel: every live offer as a ticket, then Add money. */
export default function CampaignOfferPanel({ offers, onAddMoney }: { offers: CampaignOffer[]; onAddMoney: () => void }) {
  const { t } = useTranslation();
  const now = useOfferNow();
  return (
    <div className="flex flex-col gap-3 p-4" data-testid="campaign-bonus-offers-panel">
      <div className="flex flex-col gap-0.5">
        <p className="m-0 font-display k-heading text-title text-primary">{t('campaignBonus.panelTitle', 'Deposit bonuses')}</p>
        <p className="m-0 font-ui text-small text-secondary">
          {t('campaignBonus.panelHint', 'The bonus is added with your deposit.')}
        </p>
      </div>
      <OfferTicketList offers={offers} now={now} />
      <Button variant="primary" size="lg" fullWidth icon={<Plus strokeWidth={2.5} />} onClick={onAddMoney}>
        {t('header.addMoney', 'Add money')}
      </Button>
    </div>
  );
}
